// extracted by mini-css-extract-plugin
export default {"status":"status_status__7V+lj","circle":"status_circle__S3Xag","textEllips":"status_textEllips__FoupG"};